import { type FC, useCallback } from 'react';

import { type IBank } from '../../../../types/bank';

import { BankItem } from './BankItem';

export interface IBankListItemProps {
  bank: IBank;
  onLinkClick?: (bank: IBank) => void;
}

export const BankItemController: FC<IBankListItemProps> = ({ bank, onLinkClick }) => {
  const handleLinkClick = useCallback(() => {
    if (onLinkClick) {
      onLinkClick(bank);
    }
  }, [onLinkClick, bank]);

  return (
    <BankItem logoUrl={bank.secondSquareImageUrl} name={bank.name} url={bank.searchUrl} onLinkClick={handleLinkClick} />
  );
};
